import React from 'react';
import { CodeManagementPage } from './CodeManagementPage';

export function Icd10ManagementPage() {
  return <CodeManagementPage codeType="icd10" title="ICD-10 Code Management" showChapter />;
}
